import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  button: {
    height: 36,
    transition: '.3s all ease',
  },
  openedButton: {
    width: 95,
    borderRadius: theme.spacing(8),
  },
  closedButton: {
    borderRadius: '100%',
    width: 36,
    minWidth: 'unset',
    color: theme.palette.text.primary,
  },
  buttonText: {
    marginLeft: theme.spacing(0.5),
    textTransform: 'none',
  },
  grid: {
    '& > *:not(:last-child)': {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
}))
